import { useCallback } from "react";
import { buildBodyRootMap } from "../../../utils/bodyHierarchy";
import { prunePrimarySelectionIfStaleAfterSceneGraphMutation } from "../helpers";

export function useBodyContextMenuActions({
  isPhysicsRunning,
  bodies,
  worldBodies,
  bodyDepthMap,
  sceneActions,
  clearBatchSelection,
  runGroupedBodyAction,
}) {
  const handleDeleteBodies = useCallback(
    (bodyUuids) => {
      if (isPhysicsRunning || !Array.isArray(bodyUuids) || bodyUuids.length === 0) return;
      const deleteOrder = [...bodyUuids].sort(
        (a, b) => (bodyDepthMap.get(b) ?? 0) - (bodyDepthMap.get(a) ?? 0)
      );
      runGroupedBodyAction(() => {
        deleteOrder.forEach((bodyUuid) => {
          sceneActions.removeBody(bodyUuid);
        });
      });
      prunePrimarySelectionIfStaleAfterSceneGraphMutation();
      clearBatchSelection();
    },
    [isPhysicsRunning, bodyDepthMap, runGroupedBodyAction, sceneActions, clearBatchSelection]
  );

  const handleDeleteBodyObjects = useCallback(
    (bodyUuids) => {
      if (isPhysicsRunning || !Array.isArray(bodyUuids) || bodyUuids.length === 0) return;
      const rootMap = buildBodyRootMap(bodies || {}, worldBodies || []);
      const objectRoots = Array.from(
        new Set(
          bodyUuids
            .map((bodyUuid) => rootMap[bodyUuid] || bodyUuid)
            .filter((bodyUuid) => typeof bodyUuid === "string" && bodyUuid.length > 0)
        )
      );
      if (objectRoots.length === 0) return;
      runGroupedBodyAction(() => {
        objectRoots.forEach((bodyUuid) => {
          sceneActions.removeBodyObject(bodyUuid);
        });
      });
      prunePrimarySelectionIfStaleAfterSceneGraphMutation();
      clearBatchSelection();
    },
    [isPhysicsRunning, bodies, worldBodies, runGroupedBodyAction, sceneActions, clearBatchSelection]
  );

  return {
    handleDeleteBodies,
    handleDeleteBodyObjects,
  };
}
